import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div className="grid min-h-[70vh] place-items-center px-5">
            <div className="w-full max-w-md rounded-3xl border border-caramel/10 bg-white p-10 text-center shadow-warm">
                <XCircle size={56} className="mx-auto text-mocha" />
                <h1 className="mt-5 font-serif text-3xl text-roast">Checkout canceled</h1>
                <p className="mt-2 text-mocha">No worries — your cart is still saved. Pick up right where you left off.</p>
                <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
                    <Link to="/checkout" className="rounded-full bg-caramel px-6 py-3 font-semibold text-cream-50 hover:bg-caramel-dark">Return to checkout</Link>
                    <Link to="/shop" className="rounded-full border border-caramel/30 px-6 py-3 font-semibold text-caramel hover:bg-cream-200">Keep shopping</Link>
                </div>
            </div>
        </div>
    );
}
